/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export interface ViewData {
  id?: string;
  name?: string;
  icon?: string;
  selectable?: boolean;
  hideShellMenu?: boolean;
  helpSection?: string;
}

export class View implements ViewData {
  readonly id: string;
  readonly name: string;
  readonly icon: string;
  readonly selectable: boolean;
  readonly hideShellMenu: boolean;
  readonly helpSection?: string;

  constructor(data: ViewData) {
    this.id = data.id;
    this.name = data.name;
    this.icon = data.icon;
    this.selectable = data.selectable !== undefined ? data.selectable : true;
    this.hideShellMenu = data.hideShellMenu !== undefined ? data.hideShellMenu : false;
    this.helpSection = data.helpSection === null ? undefined : (data.helpSection ?? data.id);
  }
}
